import { render, staticRenderFns } from "./MessageEditorMedia.vue?vue&type=template&id=f3b40a5c&scoped=true&"
import script from "./MessageEditorMedia.vue?vue&type=script&lang=js&"
export * from "./MessageEditorMedia.vue?vue&type=script&lang=js&"
import style0 from "./MessageEditorMedia.vue?vue&type=style&index=0&id=f3b40a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b40a5c",
  null
  
)

export default component.exports